import { Component } from '@angular/core';
import { WelcomeCard } from '../../shared/models/card.type';
import { environment } from 'src/environments/environment';
import { welcomeCards } from '../../shared/information-cards';
import { AuthService } from '../../core/services/auth/auth.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html'
})
export class WelcomeComponent {
  suggestedActionUrl: string;

  constructor(private readonly authService: AuthService) {
    this.suggestedActionUrl = this.authService.ssoUrl();
  }
}
